import { ChangeDetectionStrategy, Component, booleanAttribute, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ButtonComponent } from '../button';

@Component({
  selector: 'dmb-toggle',
  imports: [FormsModule, ButtonComponent],
  templateUrl: './toggle.html',
  styleUrl: './toggle.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toggle {
  selection = model(false);
  labelOn = input($localize`:@@Common.label.toggle-yes:Yes`);
  labelOff = input($localize`:@@Common.label.toggle-no:No`);
  disabled = input(false, { transform: booleanAttribute });

  getVariant(selection: boolean) {
    return selection ? 'toggle' : 'secondary';
  }
}
